import { GET_EVENT_COUNT, 
   GET_SPORTS_LIST, 
   SET_ACTIVE_ID, 
   SET_FILTER_ID, 
   SET_FILTER_SORT, 
   SET_SCORE_DATA, 
   SET_EVENT_COUNT, 
   SET_STORE_EVENT, 
   SET_LOCATION, 
   SET_LEAGUE, 
   SET_SEARCHVALUE, 
   SET_SEARCHTYPE, 
   SET_URL, 
   SET_LEVELBETTINGDATA, 
   SET_SPORTID, 
   SET_BET_SETTING, 
   MARKET_SETTING, 
   BASELINE_SETTING, 
   SET_PROVIDERID,
   SET_RESULT_INFO,
   SET_GAME_RESULT_LIST,
   SET_SPORTS_SETTING,
   GET_BETGAME_TYPE,
   SET_MARKETSETTING,
   SET_SPORTSMARKETINFO,
   SET_LEAGUE_COUNT,
   SET_CLIKED
} from '../actions/types';

const initialState = {
   data: [],         // sports list data
   score: [],        // sports score data
   activeId: '',     // using in live, esports, betgame pages active game id
   eventCount: {},
   filterId: 'all',  // swipbox
   filterSort: 'time', 
   location: 'all',
   league: "all",
   sportId: "all",
   searchValue: "",
   searchType: "",
   allCount: {},
   bigleagueCnt: {},
   url: "", 
   providerId: "", 
   store_events: [],
   bet_setting: [],
   levelBettingData: [],
   marketSetting: {},
   market_setting : {}, 
   baselineSetting: {},
   locations: [], 
   leagues: [], 
   gameList: [], 
   betgametype: "bet365",
   sportSetting: -1,
   sportsMarketInfo: {},
   mainsportsclicked : false
}

export default function (state = initialState, action) {
   switch (action.type) {
      case GET_SPORTS_LIST:
         return {
            ...state,
            data: action.payload
         }
      case GET_BETGAME_TYPE:
         return {
            ...state,
            betgametype: action.payload
         }
      case GET_EVENT_COUNT:
         return {
            ...state,
            eventCount: action.payload
         }
      case SET_SCORE_DATA:
         return {
            ...state,
            score: action.payload
         }
      case SET_ACTIVE_ID:
         return {
            ...state,
            activeId: action.payload
         }
      case SET_FILTER_ID:
         return {
            ...state,
            filterId: action.payload
         }
      case SET_FILTER_SORT:
         return {
            ...state,
            filterSort: action.payload
         }
      case SET_EVENT_COUNT:
            // //console.log(action.payload);
            return {
               ...state,
               allCount: action.payload
            }
      case SET_LEAGUE_COUNT:
            return {
               ...state,
               bigleagueCnt: action.payload
            }
      case SET_STORE_EVENT:
            // //console.log(action.payload);
            return {
               ...state,
               store_events: action.payload
            }
      case SET_LOCATION:
            // //console.log(action.payload);
            return {
               ...state,
               location: action.payload
            }
      case SET_LEAGUE:
            // //console.log(action.payload);
            return {
               ...state,
               league: action.payload
            }
      case SET_SEARCHVALUE:
            // //console.log(action.payload);
            return {
               ...state,
               searchValue: action.payload
            }
      case SET_SEARCHTYPE:
            // //console.log(action.payload);
            return {
               ...state,
               searchType: action.payload
            }
      case SET_SPORTID:
            // //console.log(action.payload);
            return {
               ...state,
               sportId: action.payload
            }
      case SET_URL:
            // //console.log(action.payload);
            return {
               ...state,
               url: action.payload
            }
      case SET_LEVELBETTINGDATA:
            // //console.log(action.payload);
            return {
               ...state,
               levelBettingData: action.payload
            }
      case SET_BET_SETTING:
            // console.log(action.payload);
            return {
               ...state,
               bet_setting: action.payload
            }
      case MARKET_SETTING:
            // //console.log(action.payload);
            return {
               ...state,
               marketSetting: action.payload
            }
      case BASELINE_SETTING:
            // //console.log(action.payload);
            return {
               ...state,
               baselineSetting: action.payload
            }
      case  SET_PROVIDERID:
            // //console.log(action.payload);
            return {
               ...state,
               providerId: action.payload
            }
      case SET_RESULT_INFO:
         return {
            ...state,
            locations: action.payload.location,
            leagues: action.payload.league
         }
      case SET_GAME_RESULT_LIST: 
         return {
            ...state,
            gameList: action.payload
         }
      case SET_SPORTS_SETTING: 
         return {
            ...state,
            sportSetting: action.payload
         }
      case SET_MARKETSETTING:
         return {
            ...state,
            market_setting:action.payload
         }
      case  SET_SPORTSMARKETINFO:
            return {
               ...state,
            sportsMarketInfo:action.payload
            }
      case SET_CLIKED:
            return {
               ...state,
               mainsportsclicked: action.payload
            }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/common/reducers/sportsReducer.js